/*
 * $Id:: ExpandedSection.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const ExpandedSection = ({ classes, title, content }) => (
    <div className={classes.expandedSection}>
        <ExpansionPanel className={classes.expansionPanel}>
            <ExpansionPanelSummary className={classes.expansionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.expandedSectionTitle}>{title}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expandedSectionContent}>{content}</ExpansionPanelDetails>
        </ExpansionPanel>
    </div>
);

export default ExpandedSection;
